import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #020617 0%, #0f172a 40%, #0b1229 100%);
  padding: 2rem;
  text-align: center;
`;

const Card = styled.div`
  background: rgba(15, 23, 42, 0.88);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 18px;
  padding: 3rem 2rem;
  max-width: 600px;
  box-shadow: 0 28px 50px rgba(15, 23, 42, 0.45);
`;

const SuccessIcon = styled.div`
  width: 80px;
  height: 80px;
  margin: 0 auto 2rem;
  background: rgba(52, 211, 153, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  color: #F8FAFC;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  font-size: 1.1rem;
  color: rgba(248, 250, 252, 0.75);
  line-height: 1.6;
  margin-bottom: 2rem;
`;

const InfoBox = styled.div`
  background: rgba(255, 127, 0, 0.08);
  border: 1px solid rgba(255, 127, 0, 0.3);
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  text-align: left;
`;

const InfoTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: #FF7F00;
  margin-bottom: 0.75rem;
`;

const InfoText = styled.p`
  font-size: 0.95rem;
  color: rgba(248, 250, 252, 0.85);
  line-height: 1.6;
  margin: 0;
`;

const Button = styled.a`
  display: inline-block;
  padding: 0.875rem 2rem;
  background: #FF7F00;
  color: white;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    background: #e67300;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 127, 0, 0.3);
  }
`;

const SuccessScreen = () => {
  return (
    <Container>
      <Card>
        <SuccessIcon>✓</SuccessIcon>
        <Title>Pagamento Realizado com Sucesso!</Title>
        <Message>
          Seu pagamento foi processado e sua filiação ao SETIRN está confirmada.
        </Message>

        <InfoBox>
          <InfoTitle>📧 Próximos Passos</InfoTitle>
          <InfoText>
            Em breve você receberá um e-mail de confirmação com todos os detalhes da sua filiação, 
            incluindo acesso aos benefícios exclusivos e informações sobre os próximos eventos.
          </InfoText>
        </InfoBox>

        <InfoBox>
          <InfoTitle>💼 Bem-vindo ao SETIRN</InfoTitle>
          <InfoText>
            Você agora faz parte do Sindicato das Empresas de Tecnologia da Informação do Rio Grande do Norte. 
            Nossa equipe entrará em contato em breve para dar as boas-vindas e apresentar todos os benefícios disponíveis.
          </InfoText>
        </InfoBox>

        <Button href="https://setirn.org.br" target="_blank" rel="noopener noreferrer">
          Visitar site do SETIRN
        </Button>
      </Card>
    </Container>
  );
};

export default SuccessScreen;
